module.exports = __webpack_public_path__ + "overview-a5b6df21/match-e4fa6bca64c5ae923a816a0ababe7441.svg";